import CountryPackage from "./country_package.js";

class CountryPackages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            packages: catalogModule.getPackages()
        }

        this.updatePackages = this.updatePackages.bind(this);
    }

    updatePackages() {
        this.setState({
            packages: catalogModule.getPackages()
        });
    }

    render(){
        // const packageHeader = gettext("Choose a subscription plan that\'s\ right for you");
        // const packageSubtitle = gettext("Fly safely and stress free with the latest data set you need thanks to Air Navigation Pro Subscription plans.");
        // const packageSubtitle2 = gettext("Stay relaxed: You will always have the latest versions of your products and constant updates to your database.");
        const noPackageHeader = gettext("The following products are available")
        const renderPackages = this.state.packages.length > 0 ? this.state.packages.map((storePackage, index) => {
            return <CountryPackage productPackage={storePackage}
                                   index={index}
                                   key={index}
                                   isOffSet={this.state.packages.length <= 2} />
        }) : <React.Fragment>
            <hr/>
            <h3 className="col-md-12 text-center">{noPackageHeader}</h3>
        </React.Fragment>;
        return(
            <React.Fragment>
                <div className="country_packages">
                    {/*<div className="price-country-header">*/}
                    {/*    <h2 className="text-center">*/}
                    {/*        {packageHeader}*/}
                    {/*    </h2>*/}
                    {/*    <p className="text-center">{packageSubtitle}</p>*/}
                    {/*    <p className="text-center">{packageSubtitle2}</p>*/}
                    {/*</div>*/}

                    <div className="row gy-4">
                        {renderPackages}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default CountryPackages;
